import { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import { menuCutoffUntilReceiveV2 } from 'actions/menu'
import { useActiveMenusGeneralInfo } from 'routes/Menu/domains/menu/internal/useActiveMenusGeneralInfo'

/**
 * Hook to ensure the "menu cutoff until" entry to the Redux store is update with the most recent data.
 *
 * The value is sourced from `/menus/active` resource rather than from three Menus captured in the Redux store.
 */
export const useLoadMenuCutoffUntil = () => {
  const { menus } = useActiveMenusGeneralInfo()
  const dispatch = useDispatch()

  useEffect(() => {
    if (menus && menus.length) {
      dispatch(menuCutoffUntilReceiveV2(menus[menus.length - 1].endsAt))
    }
  }, [menus, dispatch])
}
